import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssociatedProduct, ProductConfiguration } from '../../../models/fitting-query-params.model';
import { environment } from '../../../../environments/environment';
import { AssociatedProductConfigurationsModalComponent } from '../associated-product-configurations-modal/associated-product-configurations-modal.component';
import { FlatterFilesResponse } from 'src/app/models';
import { Store } from '@ngrx/store';

import * as fromFittings from '../../../store/fromFittings.barrel';
import { Observable, of, Subject, takeUntil, tap } from 'rxjs';
import { selectAssociatedPartsActiveFittingConfigurationsHasFilter, selectAssociatedPartsActiveFittingConfigurationsWithFilter, selectAssociatedPartsConfigurationQuery, selectedActiveFittingSelectedAssociatedPartConfigurations } from '../../../store/fromFittings.barrel';

@Component({
  selector: 'app-associated-products',
  templateUrl: './associated-products.component.html',
  styleUrls: ['./associated-products.component.scss']
})
export class AssociatedProductsComponent implements OnInit, OnDestroy {
  @Input() products: AssociatedProduct[] = [];
  @Output() getFittingAssociatedDrawing = new EventEmitter<string>()

  unsubscribe$ = new Subject();
  associatedProductConfigurationFilter$: Observable<ProductConfiguration[]> = of([]);
  associatedProductConfigurations$: Observable<ProductConfiguration[]> = of([]);
  associatedProductConfigurationsWithoutFilter$: Observable<ProductConfiguration[]> = of([]);

  constructor(public modalService: NgbModal, private store: Store<fromFittings.State>) { }
  ngOnInit(): void {
    this.associatedProductConfigurationFilter$ = this.store.select(selectAssociatedPartsActiveFittingConfigurationsWithFilter);
    this.associatedProductConfigurations$ = this.store.select(selectAssociatedPartsActiveFittingConfigurationsWithFilter);
    this.associatedProductConfigurationsWithoutFilter$ = this.store.select(selectedActiveFittingSelectedAssociatedPartConfigurations);
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  viewConfigurations(partNumber: string): void {
    this.store.dispatch(fromFittings.changeActiveAssociatedPart({ partNumber: partNumber }));

    const modal = this.modalService.open(AssociatedProductConfigurationsModalComponent, { ...environment.modalOptions, size: 'lg' });

    modal.componentInstance.partNumber = partNumber;
    this.associatedProductConfigurationFilter$.pipe(takeUntil(this.unsubscribe$)).subscribe(res => modal.componentInstance.configurationFilter = res);
    this.associatedProductConfigurations$.pipe(takeUntil(this.unsubscribe$)).subscribe(res => modal.componentInstance.configurations = res);
    this.associatedProductConfigurationsWithoutFilter$.pipe(takeUntil(this.unsubscribe$)).subscribe(res => modal.componentInstance.configurationsWithoutFilter = res);

    modal.componentInstance.ngAfterViewInit();
  }
}
